import Model from "../../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const DeleteItem = ({
    setIsDeleteItem,
    selectedData,
    deleteItemLoading,
    deleteItemMutate,
}) => {
    const handleDeleteSubmit = () => {
        deleteItemMutate({
            itemId: selectedData?.id,
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteItem}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this item?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteItem(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteItemLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteItemLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteItem;